import React from 'react';
import { IconTrendingUp, IconTrendingDown, IconMinus } from '@tabler/icons-react';
import { useExchangeRateTrend } from '../../hooks/use-exchange-rate-trend';
import { useI18n } from '../../locales/i18n-context';
import './exchange-rate-ticker.css';

const TREND_COLORS: Record<string, string> = {
  up: 'var(--cb-success)',
  down: 'var(--cb-danger)',
  stable: 'var(--cb-text-muted)',
};

const TREND_ICONS = { up: IconTrendingUp, down: IconTrendingDown, stable: IconMinus };

export const ExchangeRateTicker: React.FC = () => {
  const { rate, trend, flashing } = useExchangeRateTrend();
  const { t } = useI18n();

  if (rate === null) return null;

  const TrendIcon = TREND_ICONS[trend];

  return (
    <div
      className={`cb-exchange-ticker${flashing ? ' cb-exchange-ticker--flash' : ''}`}
      title={t('dashboard.exchangeRate')}
    >
      <TrendIcon size={14} style={{ color: TREND_COLORS[trend] }} />
      <span>GCS/ICS</span>
      <span className="cb-exchange-ticker__rate">{rate.toFixed(4)}</span>
    </div>
  );
};
